import React, { useState, forwardRef } from "react"
import { default as ReactDatePicker } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import styled from "styled-components"
import Input, { InputProps } from "."
import { ReactComponent as CalendarIcon } from '@icons/calendar.svg'
import useUpdateEffect from "@hooks/useUpdateEffect"

function Datepicker({ defaultValue, ...props }: InputProps, ref: any) {
    const [date, setDate] = useState(typeof defaultValue === "string" ? new Date(defaultValue) : undefined)
    useUpdateEffect(() => setDate(typeof defaultValue === "string" ? new Date(defaultValue) : undefined), [defaultValue])

    const handleChange = (date: Date, event: React.SyntheticEvent) => {
        setDate(date)
    }

    return (
        <DatepickerWrapper>
            <ReactDatePicker customInput={<Input {...props} icon={<CalendarIcon />} type="text" ref={ref} />} name={props.name} placeholderText={props.placeholder} selected={date} onChange={handleChange} />
        </DatepickerWrapper>
    )
}

export default forwardRef(Datepicker)

// STYLES
const DatepickerWrapper = styled.div`
    width: 100%;

    & > div {
        width: 100%;
    }

    .react-datepicker-popper {
        z-index: 99;
    }
`